var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeAltCircleBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #747474;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.2,11.8l-3.4-1.9c-.1-.1-.3,0-.3.2v3.8c0,.2.1.3.3.2l3.4-1.8c.1-.2.1-.4,0-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12,12-5.4,12-12S18.6,0,12,0ZM19.4,14c0,1.8-1.5,3.2-3.2,3.2H7.8c-1.8,0-3.2-1.5-3.2-3.2v-4c0-1.8,1.5-3.2,3.2-3.2h8.4c1.8,0,3.2,1.5,3.2,3.2,0,0,0,4,0,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeAltCircleBlanco);
export default __webpack_public_path__ + "static/media/youtube-alt-circle-blanco.87a9e64583a0605cb841b137505834db.svg";
export { ForwardRef as ReactComponent };